import React, {useMemo, useCallback, useState, useEffect, useContext, Fragment} from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { styled } from '@mui/material/styles';

import _ from "lodash";
import Player from '../Player';
import FullscreenWrapper from '../FullscreenWrapper';

import { getImage, GatsbyImage } from "gatsby-plugin-image";

import { Box, } from "@mui/material";
import Carousel, { CaptionDiv } from '../Carousel/Carousel';

import { navigate } from "gatsby-link";

import { getEntityUrl } from "../../util";

import { GlobalContext } from '../GlobalContext';

import { TourContext } from "../Tour/TourContext";
import {OverlayIcon} from "../Overlay/OverlayIcon";

const PlayerDiv = styled('div', { shouldForwardProp: () => true })(({ fullscreenMode }) => {
    return fullscreenMode && {
        position: 'absolute',
        bottom: 0,
        width: '100%',
    }
});

const OverlayText = styled('div')(() => ({
    position: 'absolute',
    zIndex: 65534,
    display: 'block',
    bottom: 0,
    width: "100%",
    padding: "6px",
    paddingBottom: "12px",
    opacity: "1!important",
    background: "#333",

    [`& p`]: {
        color: '#fff',
    },
}));

const OverlayToggle = styled('div')(() => ({//TODO
    display: 'block',
    position: 'absolute',
    bottom: 26,
    left: 5,
    zIndex: 65535,
    color: '#fff',
    lineHeight: 1,
    padding: '5px 5px 2px 5px',
    background: 'rgb(0 0 0 / 34%)',
    borderRadius: '100%',
    margin: 0,

}));

const CaptionsDiv = styled('div', { shouldForwardProp: () => true })(({ fullscreenMode }) => {
    const style = {
        flex: 1,
    };
    if (fullscreenMode) {
        style.position = 'absolute';
        style.bottom = '36px';
        style.width = '100%';
    }
    return style;
});

const FlexDiv = styled('div')(() => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
}));


const Imageplayer = (props) => {
    const { component, entity, files, pageContext } = props;
    const { fullscreenMode } = useContext(GlobalContext);

    const { isTour, skipToNext } = useContext(TourContext);

    const [caption, setCaption] = useState('');
    const [overlayText, setOverlayText] = useState('');

    const [images, timestamps] = useMemo(() => {
        const images = {};
        _.each(component.image,
            ({ image, timestamp, caption, overlayText }) => {
                const key = parseInt(timestamp || 0);

                images[key] = {
                    localFile: _.find(files.nodes, { id: image?.localFile___NODE }),
                    timestamp: key,
                    caption,
                    overlayText
                }
            });

        const sortedKeys = Object.keys(images).sort((a, b) => a - b);

        return [images, sortedKeys];
    }, [files, component]);

    const audioUrl = useMemo(() => {
        return _.find(files.nodes, { id: component.audio?.localFile___NODE })?.publicURL;
    }, [files, component]);


    const [currentTimestamp, setCurTimeIndex] = useState(0);
    const onProgress = useCallback(({ playedSeconds, type, target, ...props }) => {
        let seconds = playedSeconds;
        if (type === 'timeupdate') seconds = target.currentTime;

        const playedMs = parseInt(seconds * 1000);

        const selTime = timestamps.reduce((prev, curr) => {
            return playedMs > curr ? curr : prev
        });

        setCurTimeIndex(timestamps.findIndex(e => e === selTime));
    }, [setCurTimeIndex, timestamps]);

    const { defaultLocale } = pageContext;
    const onEnded = () => {
        if (isTour) skipToNext();
        else if (component.continueTo) navigate(getEntityUrl({ entity: component.continueTo, defaultLocale }));
        else if (fullscreenMode) navigate(-1);
    }

    const onCarouselChange = useCallback((i) => {
        setCaption(images[timestamps[i]].caption);
        setOverlayText(images[timestamps[i]].overlayText);
    }, [images, timestamps, setCaption, setOverlayText]);

    const carouselProps = {
        infiniteLoop: true,
        showThumbs: false,
        showStatus: false,
        selectedItem: currentTimestamp,
        showIndicators: component.swipeable || false,
        showArrows: component.swipeable || false,
        swipeable: !component.zoomable && (component.swipeable || false),
        onChange: onCarouselChange,
    };

    useEffect(() => {
        onCarouselChange(0);
    }, []);

    const [overlayTextHidden, setOverlayTextHidden] = useState(true);
    const onOverlayToggle = useCallback((e) => {
        setOverlayTextHidden(!overlayTextHidden);
        e.preventDefault(); e.stopPropagation();
    }, [overlayTextHidden]);

    const zoomWrapperStyle = { width: '100%', margin: '0 auto' };
    if (fullscreenMode) {
        zoomWrapperStyle.maxHeight = '-webkit-fill-available';
        zoomWrapperStyle.height = '95vh';
    }

    const [zoomRef, setZoomRef] = useState(null);
    const zoomRefCb = useCallback((node) => {
        setZoomRef(node);
    }, [setZoomRef]);

    useEffect(() => {
        const centerZoom = () => {
            setTimeout(() => { if (zoomRef) zoomRef.centerView() }, 50);
        }

        window.addEventListener('resize', centerZoom);
        return () => window.removeEventListener('resize', centerZoom)
    }, [zoomRef]);

    return (
            <FullscreenWrapper {...props}> {
                timestamps.length > 0 && (
                    <FlexDiv>
                        <div style={{ position: 'relative' }}>
                            {overlayText && (
                                <OverlayToggle className="overlay-toggle" onClick={onOverlayToggle} ><OverlayIcon fontSize="medium" /></OverlayToggle>
                            )}
                            {
                                <Carousel carouselProps={carouselProps} className="imageplayer" hasCaption={true} fullscreenMode={fullscreenMode} >
                                    {timestamps.map(k =>
                                        <Fragment key={k}>

                                            <OverlayText className="richtext overlay-text" style={{ display: overlayTextHidden ? 'none' : 'block' }} dangerouslySetInnerHTML={{ __html: overlayText }} />

                                            <Box align="center" key={k}>
                                                <TransformWrapper centerOnInit={true} disabled={component.zoomable !== true} ref={zoomRefCb} >
                                                    <TransformComponent wrapperStyle={zoomWrapperStyle} wrapperClass='zoomWrapper'>
                                                        <GatsbyImage
                                                            image={getImage(images[k].localFile)}
                                                            style={{ width: '100%' }}
                                                            alt=""
                                                            loading={k === 0 ? 'eager' : 'lazy'}
                                                            objectFit="contain" position="static"
                                                            imgStyle={{ position: 'static', height: `${component.height || 60}vh`, verticalAlign: 'center' }}
                                                        />
                                                    </TransformComponent>
                                                </TransformWrapper>
                                            </Box>
                                        </Fragment>
                                    )}
                                </Carousel>
                            }
                        </div>

                        {caption !== '' &&
                            <CaptionsDiv className="richtext caption-inline" fullscreenMode={fullscreenMode}>
                                <div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: caption }} />
                            </CaptionsDiv>
                        }

                        {audioUrl !== undefined &&
                            <PlayerDiv fullscreenMode={fullscreenMode}>
                                <Player style={{ paddingTop: 12 }} width='100%' height='42px'
                                    url={audioUrl}
                                    controls={true}
                                    loop={ (!isTour && component.loop) || false}
                                    playing={component.autoplay || false}
                                    playsinline={component.fullscreen || false}
                                    onProgress={onProgress}
                                    onEnded={onEnded}
                                    fullscreenMode={fullscreenMode}
                                />
                            </PlayerDiv>
                        }
                    </FlexDiv>
                )}
            </FullscreenWrapper>
    );
}

export default Imageplayer;
